<template>
  <div class="details">
    <schedule-info
      v-for="(schedule,index) in obsoleteList"
      :key="schedule.id"
      :data="schedule"
      :title="`课程表-已结束${index+1}`"
      @deletedSchedule="deletedSchedule"
    />
  </div>
</template>
<script>
import axClient from '@/services';
import scheduleInfo from './scheduleInfo.vue';

export default {
  name: 'AccountDetails',
  components: {
    scheduleInfo,
  },
  data() {
    return {
      obsoleteList: [],
      courseId: null,
    };
  },
  created() {
    this.courseId = localStorage.getItem('courseHistoryId');
    this.getInfo();
  },
  methods: {
    // 详情
    async getInfo() {
      console.log(this.courseId);
      if (!this.courseId) return;
      const obsolete = await axClient.course.listDetailSchedule({ courseId: this.courseId, queryType: 20 });
      if (obsolete) {
        this.obsoleteList = obsolete;
      }
    },
    // 删除课程表
    deletedSchedule(item) {
      this.$confirm('确定删除该课程表？', '删除该课程表', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        showClose: false,
        type: 'error',
      }).then(async() => {
        const { id } = item;
        const data = await axClient.course.deleteSchedule({ id });
        if (data) {
          this.$message.success('删除成功');
          this.getInfo();
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.details {
  .title {
    margin-top: 12px;
  }
  .custom-tree-node {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex: 1;
    font-size: 0;
    .name {
      font-size: 16px;
    }
    .url{
      padding-left: 15px;
      color: $--base-color-main;
      font-size: 14px;
    }
    .line {
      flex: 1;
      height: 1px;
      margin-left: 12px;
      background: rgba($--base-color-black, 0.2);
    }
  }
  .switch-btns {
    padding-top: 20px;
  }
}
</style>